import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const { language } = useLanguage();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  const content = {
    en: {
      message: 'We use cookies to improve your experience.',
      accept: 'Accept',
      decline: 'Decline'
    },
    tr: {
      message: 'Size daha iyi hizmet sunmak için çerezleri kullanıyoruz.',
      accept: 'Kabul Et',
      decline: 'Reddet'
    }
  };

  const text = content[language];

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 border-t border-gray-700 shadow-2xl">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Cookie Icon and Message */}
            <div className="flex items-center space-x-3 text-white">
              <div className="bg-white/10 p-2 rounded-lg backdrop-blur-sm">
                <Cookie size={24} className="text-blue-400" />
              </div>
              <p className="text-sm md:text-base font-medium">
                {text.message}
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center space-x-3 w-full md:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 md:flex-none px-6 py-2.5 bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium rounded-lg transition-all duration-200 hover:scale-105"
              >
                {text.decline}
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 md:flex-none px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-all duration-200 hover:scale-105 shadow-lg"
              >
                {text.accept}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
